import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
export const InfoLine = ({ children, clearPadding = false, dataHook, maxLines, weight, type, ...rest }) => {
    if (!children) {
        return null;
    }
    const renderText = () => type === 'heading' ? (React.createElement(Heading, { size: "medium", maxLines: maxLines, dataHook: dataHook + '.heading' }, children)) : (React.createElement(Text, { size: type === 'subtext' ? 'tiny' : 'small', weight: weight, maxLines: maxLines, dataHook: dataHook + '.text' }, children));
    if (clearPadding && !Object.keys(rest).length) {
        return renderText();
    }
    return (React.createElement(Box, { paddingTop: clearPadding ? 0 : '4px', dataHook: dataHook, ...rest }, renderText()));
};
//# sourceMappingURL=InfoLine.js.map